"use strict";

var _toConsumableArray = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var export_class_1 = require("../code-object/export-class");

var method_1 = require("../code-object/method");

var local_context_1 = require("../code-object/local-context");

var inline_context_1 = require("../code-object/inline-context");

var RefreshDraftPlugin =
/*#__PURE__*/
function () {
  function RefreshDraftPlugin(transcriber) {
    _classCallCheck(this, RefreshDraftPlugin);

    this.m_Transcriber = transcriber;
  }

  _createClass(RefreshDraftPlugin, [{
    key: "Transcribe",
    value: function Transcribe() {
      var _this = this;

      this.m_Transcriber.m_ClassMap.clear();
      this.m_Transcriber.m_MethodMap.clear();
      this.m_Transcriber.m_ContextMap.clear();
      this.m_Transcriber.m_InlineContextMap.clear();
      var draft = this.m_Transcriber.m_Module.ToDraft();
      draft.forEach(function (each) {
        var _a;

        if (each instanceof export_class_1.ExportClassCode) {
          _this.m_Transcriber.m_ClassMap.set(each.m_Name, each);
        } else if (each instanceof local_context_1.LocalContext) {
          _this.m_Transcriber.m_ContextMap.set(each.m_Name, each);
        } else if (each instanceof inline_context_1.InlineContext) {
          _this.m_Transcriber.m_InlineContextMap.set(each.m_ID, each);
        } else if (each instanceof method_1.MethodCode) {
          var class_name = each.m_ClassName;
          var methods = (_a = _this.m_Transcriber.m_MethodMap.get(class_name)) !== null && _a !== void 0 ? _a : [];

          _this.m_Transcriber.m_MethodMap.set(class_name, [].concat(_toConsumableArray(methods), [each]));
        }
      });
    }
  }]);

  return RefreshDraftPlugin;
}();

exports.RefreshDraftPlugin = RefreshDraftPlugin;